var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPunktLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.86 32.51"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "punkt-logo_inline_svg__solid",
    d: "M36.7 7.66h-4.54v10.12c0 2.26-1 4.76-4.46 4.76-2.31 0-3.35-1.12-3.35-3.72V7.66h-4.56v12.46c0 5.47 3.69 6.8 6.88 6.8a6.6 6.6 0 005.4-2.3h.07v1.86h4.54zM38.34 26.48h4.54v-9.93c0-3.46 1.82-5 4-5S50 13.28 50 15v11.48h4.54V13.61c0-4.13-2-6.4-6.47-6.4a6.57 6.57 0 00-5.13 2.31h-.08V7.66h-4.52zM0 32.51h4.53v-7.84a6.45 6.45 0 005.35 2.26c4.83 0 8.17-4.42 8.17-9.84S14.71 7.25 10 7.25a7.67 7.67 0 00-5.35 2h-.12v-1.6H0zm8.84-9.73c-3.42 0-4.42-3-4.46-5.68s1-5.68 4.46-5.68 4.42 3 4.46 5.68-1.04 5.68-4.46 5.68zM56.23 26.48h4.53v-5.91l2.57-2.53 5.62 8.44h5.54l-8-11.49 7.29-7.33H67.9l-7.14 7.07V0h-4.53v26.48zM82.39 26.48l-.01-15.01h3.48V7.66h-3.48V1h-4.53v6.66h-2.76v3.81h2.76v15.01h4.54z"
  })));
}

export default SvgPunktLogoinline;